import {Tabs} from 'antd';
import {checkPerm} from "../../auth/sessionTools";
import {TaskTable} from "../tasks/TaskTable";
import {NewPurchaseOrder} from "../sales/NewPurchaseOrder";
import {ExistingPurchaseOrder} from "../sales/ExistingPurchaseOrder";

export const RetailTab = ({onApiFail, session, refresh, onRefresh, props}) => {
    const hasAllTasks = checkPerm(session, "allTask");

    const items = [
        {
            key: 'NewPurchaseOrder',
            label: 'New Purchase Order',
            children: <NewPurchaseOrder onRefresh={onRefresh} onApiFail={onApiFail} />
        },
        {
            key: 'ExistingPurchaseOrder',
            label: 'Existing Purchase Order',
            children: <ExistingPurchaseOrder session={session} refresh={refresh} onRefresh={onRefresh} onApiFail={onApiFail} />
        }
    ]

    if (hasAllTasks) {
        items.push({
            key: 'DepartmentTasks',
            label: 'Retail Tasks',
            children: <TaskTable refresh={refresh} onApiFail={onApiFail} taskType={'department'} showVerified={false} department={`TrapconRetailNordhoff`} />
        });
    }

    return <Tabs tabPosition={'left'} defaultActiveKey={'DepartmentTasks'} items={items} />
}